// Portfolio Images
import BeSocial from "../assets/projects/BeSocial.jpg";
import Command from "../assets/projects/Commandtest.png";
import DownTube from "../assets/projects/DownTube.jpg";
import FeelTRX from "../assets/projects/Feeltrx.png";
import Khullabazzar from "../assets/projects/Khullabazzar.jpg";
import RentYourCar from "../assets/projects/RentYourCar.jpg";
import StaffSync from "../assets/projects/StaffSync.png";
import Testimonify from "../assets/projects/Testimonify.png";
import NexusChat from "../assets/projects/Nexuschat.png";
import Animity from "../assets/projects/Animity.png";
import AutoSummary from "../assets/projects/AutoSummary.png";
import Mindmap from "../assets/projects/Mindmap.png";
import RojanSolves from "../assets/projects/RojanSolves.png";
import SFC from "../assets/projects/SFC.png";

// Certifications Images
import BackendDevandAPIs_fcc from "../assets/certifications/BackendDevandAPIs_fcc.png";
import CSS_Sololearn from "../assets/certifications/CSS_Sololearn.jpg";
import DataVisualization_fcc from "../assets/certifications/DataVisualization_fcc.png";
import FrontendDevLibraries_fcc from "../assets/certifications/FrontendDevLibraries_fcc.png";
import HTML_Sololearn from "../assets/certifications/HTML_Sololearn.jpg";
import JSDSA_fcc from "../assets/certifications/JSDSA_fcc.png";
import ResWebDesign_fcc from "../assets/certifications/ResWebDesign_fcc.png";
import CSharp_Sololearn from "../assets/certifications/csharp.jpg";

// Resume File
import ResumeFile from "../assets/resume/resume.pdf";

// User Data
export const user = {
  id: 1,
  name: "Rojan Acharya",
  stack: "SAAS Enthusiast | Developer",
  description: `As a passionate SaaS developer, I am dedicated to continuous learning and staying ahead with the latest technologies. My expertise spans full-stack web development, cloud solutions, and scalable SaaS architectures. I thrive on building robust, high-performance applications using modern frameworks and best practices. My commitment to quality, adaptability, and innovation ensures I deliver exceptional results in dynamic environments.`,
  support: "Everyday",
  avatar: "../assets/images/logo.jpeg",
  experience: "2 years",
};

// User Resume
export const resume = {
  resume_link: "https://onelinkresume.rojanacharya.com/r/nm2gdnknjahsvb31vus9",
  resume_file: ResumeFile,
};

// Skill name to ID mapping for easier reference
const skillNameToId = {
  nextjs: 2,
  mysql: 3,
  "react native": 4,
  typescript: 5,
  aws: 6,
  mongodb: 7,
  nodejs: 8,
  express: 9,
  python: 10,
  postgres: 11,
  javascript: 12,
  elixir: 13,
  erlang: 14,
  supabase: 15,
  flutter: 16,
  react: 17,
  "framer motion": 18,
  webrtc: 19,
  "data visualization": 20,
  css: 21,
  redux: 22,
  bootstrap: 23,
  jquery: 24,
  sass: 25,
  html: 26,
  "d3.js": 27,
  tailwindcss: 28,
  zustand: 29,
  openai: 30,
};

// Add missing skills to the skill array if not present
// (TailwindCSS, Zustand)
export const skill = [
  {
    id: 2,
    skill_name: "NextJS",
    level: "Intermediate",
    description:
      "Next.js is a React framework for server-side rendering, static site generation, and building SEO-friendly, high-performance web applications.",
  },
  {
    id: 3,
    skill_name: "MySQL",
    level: "Intermediate",
    description:
      "MySQL is a popular open-source relational database management system known for its reliability, scalability, and SQL support.",
  },
  {
    id: 4,
    skill_name: "React Native",
    level: "Beginner",
    description:
      "React Native enables cross-platform mobile app development using JavaScript and React, delivering native performance for iOS and Android.",
  },
  {
    id: 5,
    skill_name: "TypeScript",
    level: "Intermediate",
    description:
      "TypeScript is a strongly typed superset of JavaScript that enhances code quality, maintainability, and developer productivity.",
  },
  {
    id: 6,
    skill_name: "AWS",
    level: "Beginner",
    description:
      "Amazon Web Services (AWS) provides scalable cloud computing, storage, and deployment solutions for modern web applications.",
  },
  {
    id: 7,
    skill_name: "MongoDB",
    level: "Intermediate",
    description:
      "MongoDB is a NoSQL document database designed for scalability, flexibility, and high performance in modern web applications.",
  },
  {
    id: 8,
    skill_name: "Node.js",
    level: "Intermediate",
    description:
      "Node.js is a JavaScript runtime for building fast, scalable server-side and networking applications.",
  },
  {
    id: 9,
    skill_name: "Express",
    level: "Intermediate",
    description:
      "Express is a minimal and flexible Node.js web application framework for building robust APIs and web servers.",
  },
  {
    id: 10,
    skill_name: "Python",
    level: "Beginner",
    description:
      "Python is a versatile, high-level programming language widely used for web development, data science, and automation.",
  },
  {
    id: 11,
    skill_name: "PostgreSQL",
    level: "Intermediate",
    description:
      "PostgreSQL is an advanced open-source relational database with powerful features for data integrity and complex queries.",
  },
  {
    id: 12,
    skill_name: "JavaScript",
    level: "Intermediate",
    description:
      "JavaScript is the core scripting language for web development, enabling dynamic, interactive user experiences.",
  },
  {
    id: 13,
    skill_name: "Elixir",
    level: "Beginner",
    description:
      "Elixir is a functional programming language for building scalable, maintainable applications, running on the Erlang VM.",
  },
  {
    id: 14,
    skill_name: "Erlang",
    level: "Beginner",
    description:
      "Erlang is a concurrent, functional language designed for building scalable, fault-tolerant distributed systems.",
  },
  {
    id: 15,
    skill_name: "Supabase",
    level: "Intermediate",
    description:
      "Supabase is an open-source backend-as-a-service platform for building secure, scalable web and mobile applications.",
  },
  {
    id: 16,
    skill_name: "Flutter",
    level: "Beginner",
    description:
      "Flutter is a UI toolkit for building natively compiled applications for mobile, web, and desktop from a single codebase.",
  },
  {
    id: 17,
    skill_name: "React",
    level: "Intermediate",
    description:
      "React is a declarative JavaScript library for building fast, interactive user interfaces and single-page applications.",
  },
  {
    id: 18,
    skill_name: "Framer Motion",
    level: "Intermediate",
    description:
      "Framer Motion is a production-ready React animation library for creating complex, smooth UI animations.",
  },
  {
    id: 19,
    skill_name: "WebRTC",
    level: "Beginner",
    description:
      "WebRTC is a technology for real-time peer-to-peer audio, video, and data communication in web browsers.",
  },
  {
    id: 20,
    skill_name: "Data Visualization",
    level: "Intermediate",
    description:
      "Data Visualization involves using libraries like D3.js and Chart.js to create interactive, insightful charts and dashboards.",
  },
  {
    id: 21,
    skill_name: "CSS",
    level: "Intermediate",
    description:
      "CSS (Cascading Style Sheets) is used to style and layout web pages, enabling responsive and visually appealing designs.",
  },
  {
    id: 22,
    skill_name: "Redux",
    level: "Intermediate",
    description:
      "Redux is a predictable state container for JavaScript apps, commonly used with React for managing application state.",
  },
  {
    id: 23,
    skill_name: "Bootstrap",
    level: "Intermediate",
    description:
      "Bootstrap is a popular CSS framework for building responsive, mobile-first web projects quickly and efficiently.",
  },
  {
    id: 24,
    skill_name: "jQuery",
    level: "Beginner",
    description:
      "jQuery is a fast, small JavaScript library that simplifies HTML document traversal, event handling, and animation.",
  },
  {
    id: 25,
    skill_name: "SASS",
    level: "Intermediate",
    description:
      "SASS is a CSS preprocessor that adds power and elegance to the basic language, enabling variables, nesting, and more.",
  },
  {
    id: 26,
    skill_name: "HTML",
    level: "Intermediate",
    description:
      "HTML (HyperText Markup Language) is the standard markup language for creating web pages and web applications.",
  },
  {
    id: 27,
    skill_name: "D3.js",
    level: "Intermediate",
    description:
      "D3.js is a JavaScript library for producing dynamic, interactive data visualizations in web browsers.",
  },
  // Add TailwindCSS and Zustand if not present
  {
    id: 28,
    skill_name: "TailwindCSS",
    level: "Intermediate",
    description:
      "TailwindCSS is a utility-first CSS framework for rapidly building custom user interfaces with low-level utility classes.",
  },
  {
    id: 29,
    skill_name: "Zustand",
    level: "Beginner",
    description:
      "Zustand is a small, fast, and scalable state-management solution for React applications.",
  },
  {
    id: 30,
    skill_name: "OpenAI",
    level: "Intermediate",
    description:
      "OpenAI is a platform for building AI applications, providing powerful APIs for natural language processing, image generation, and more.",
  },
];

// Helper to get skill IDs from names (case-insensitive)
function getSkillIds(skillNames) {
  return skillNames
    .map((name) => {
      const key = name.trim().toLowerCase();
      return skillNameToId[key];
    })
    .filter(Boolean);
}

// Portfolio Data
export const projects = [
  {
    id: 1,
    project_title: "Mindmap AI - Instantly Visualize Your Thoughts",
    project_image: Mindmap,
    project_desc: `
      <h3>Mindmap AI: Instantly Visualize Your Thoughts</h3>
      <p>Mindmap AI is an intelligent mind mapping tool that allows you to take your raw ideas and seamlessly convert them into structured, interactive mindmaps—powered by advanced AI.</p>
      <p><em>- Just describe your thoughts or goals, and Mindmap AI organizes them into a dynamic mindmap—no manual dragging or designing required.</em></p>
      <p><em>- Use the prompt box to write or tap the mic to dictate your ideas. See them visualized in seconds.</em></p>
      <p><em>- Perfect for brainstorming, planning, studying, and workflow design.</em></p>
      <p><em>- User-friendly, beautiful interface for idea exploration and refining concepts.</em></p>
      <p><em>- Built with the latest tech for intuitive mindmap generation and management.</em></p>
    `,
    project_link: "https://mindmap-ai-psi.vercel.app/",
    skillIds: getSkillIds([
      "react",
      "nextjs",
      "openai",
      "typescript",
      "tailwindcss",
    ]),
  },
  {
    id: 2,
    project_title: "AutoSummary - AI Summarization Platform",
    project_image: AutoSummary,
    project_desc: `
    <h3>AutoSummary: AI-Powered Content Summarization</h3>
    <p>AutoSummary is an intelligent AI platform that delivers instant TL;DR summaries for text, emails, and threads across multiple platforms. Built with Next.js, TypeScript, TailwindCSS, and OpenAI APIs, it helps users save hours daily by transforming information overload into concise insights.</p>
    <p><em>- 1-Click summarization with contextual understanding</em></p>
    <p><em>- Multi-platform Chrome extension (Gmail, Outlook, LinkedIn, X, GitHub, etc.)</em></p>
    <p><em>- Smart tagging, organization, and search features</em></p>
    <p><em>- Tiered pricing (Free, Pro, Elite) with analytics and advanced integrations</em></p>
    <p><em>- Built with scalable architecture for real-time AI summaries</em></p>
  `,
    project_link: "https://autosummary.rojanacharya.com/",
    skillIds: getSkillIds(["nextjs", "typescript", "tailwindcss", "openai"]),
  },
  {
    id: 3,
    project_title: "Rojan Solves - Interactive Problem Solutions",
    project_image: RojanSolves,
    project_desc: `
    <h3>Rojan Solves: Interactive Coding Solutions</h3>
    <p>Rojan Solves is a curated collection of algorithmic and frontend challenges built with React, TypeScript, and Next.js. It provides interactive solutions and visualizations to coding problems across difficulty levels — from beginner UI components to complex algorithm visualizers.</p>
    <p><em>- 38+ categorized problems (Easy, Medium, Hard)</em></p>
    <p><em>- Real-time algorithm visualizations (Sorting, Pathfinding, Data Structures)</em></p>
    <p><em>- Clean, educational UI built for learning and exploration</em></p>
    <p><em>- Built with modular architecture and reusable components</em></p>
    <p><em>- Deployed on Vercel for seamless performance</em></p>
  `,
    project_link: "https://solution.rojanacharya.com/",
    skillIds: getSkillIds(["nextjs", "react", "typescript", "tailwindcss"]),
  },
  {
    id: 4,
    project_title: "Stripe Feedback Collector - Checkout Insights Tool",
    project_image: SFC,
    project_desc: `
    <h3>Stripe Feedback Collector (SFC): Checkout Insights Platform</h3>
    <p>Stripe Feedback Collector helps founders and developers understand customer behavior during Stripe Checkout. Built with Next.js, TypeScript, and Stripe API, it automatically gathers post-checkout feedback to reveal why users complete or abandon payments.</p>
    <p><em>- One-click integration via success and cancel URLs</em></p>
    <p><em>- Collects structured feedback from real customers</em></p>
    <p><em>- Smart analytics and sentiment tracking dashboard</em></p>
    <p><em>- Simple, transparent pricing with Free, Premium, and Lifetime plans</em></p>
    <p><em>- Designed for UX optimization and conversion improvement</em></p>
  `,
    project_link: "https://sfc.rojanacharya.com/",
    skillIds: getSkillIds(["nextjs", "typescript", "tailwindcss", "react"]),
  },
  {
    id: 5,
    project_title: "Testimonify - AI-Powered Testimonials",
    project_image: Testimonify,
    project_desc: `
      <h3>Testimonify: AI-Powered Testimonial Platform</h3>
      <p>Testimonify is an advanced testimonial and review platform featuring AI-driven sentiment analysis and data visualization. Built with Next.js, MongoDB, TypeScript, Node.js, Express, Redux, React, and TailwindCSS, it enables businesses to collect, analyze, and showcase customer feedback with ease.</p>
      <p><em>- Multi-format testimonials: text, image, audio, video</em></p>
      <p><em>- AI-powered analytics and sentiment analysis (Python NLP)</em></p>
      <p><em>- Customizable, SEO-optimized testimonial pages</em></p>
      <p><em>- Secure authentication and social sharing</em></p>
    `,
    project_link: "https://www.testimonify.rojanacharya.com/",
    skillIds: getSkillIds([
      "nextjs",
      "mongodb",
      "typescript",
      "nodejs",
      "express",
      "redux",
      "react",
      "tailwindcss",
    ]),
  },

  {
    id: 6,
    project_title: "Animity - Free Animated Icons",
    project_image: Animity,
    project_desc: `
      <h3>Animity: Free Animated Icon Library</h3>
      <p>Animity is a curated collection of free, customizable animated icons. Built with Next.js, TailwindCSS, TypeScript, Framer Motion, React, and Node.js, it empowers developers and designers to enhance user interfaces with lightweight, scalable SVG animations.</p>
      <p><em>- 100% customizable and scalable SVG icons</em></p>
      <p><em>- Ready-to-use with TypeScript and React</em></p>
      <p><em>- Inspired by Lucide React and built for performance</em></p>
      <p><em>- Perfect for SaaS dashboards, landing pages, and web apps</em></p>
    `,
    project_link: "https://animity.rojanacharya.com/",
    skillIds: getSkillIds([
      "nextjs",
      "tailwindcss",
      "typescript",
      "framer motion",
      "react",
      "nodejs",
    ]),
  },
  {
    id: 7,
    project_title: "NexusChat - Real-Time Chat Platform",
    project_image: NexusChat,
    project_desc: `
      <h3>NexusChat: Real-Time Messaging App</h3>
      <p>NexusChat is a scalable real-time chat application leveraging Next.js, TailwindCSS, TypeScript, Framer Motion, MongoDB, React, Erlang, Elixir, WebRTC, and Redux for robust backend communication, live calling, and a seamless, responsive user experience.</p>
      <p><em>- Real-time messaging with WebSocket and Erlang backend</em></p>
      <p><em>- Live calling and video chat with WebRTC</em></p>
      <p><em>- Emoji support, authentication, and secure user management</em></p>
      <p><em>- Mobile-first responsive design</em></p>
    `,
    project_link: "https://nexuschat.rojanacharya.com/",
    skillIds: getSkillIds([
      "nextjs",
      "tailwindcss",
      "typescript",
      "framer motion",
      "mongodb",
      "react",
      "erlang",
      "elixir",
      "webrtc",
      "redux",
    ]),
  },
  {
    id: 8,
    project_title: "Windows Command Simulator",
    project_image: Command,
    project_desc: `
      <h3>Windows Command Simulator</h3>
      <p>Simulate Windows command prompt operations in the browser with this interactive tool. Built with Next.js, React, TypeScript, TailwindCSS, Framer Motion, and Zustand, it features real-time command execution, intelligent auto-complete, and persistent command history.</p>
      <p><em>- Real-time command execution and feedback</em></p>
      <p><em>- Interactive UI with Framer Motion animations</em></p>
      <p><em>- Context-aware auto-complete and command history</em></p>
      <p><em>- Mobile and desktop responsive design</em></p>
    `,
    project_link: "https://commandtest.rojanacharya.com/",
    skillIds: getSkillIds([
      "nextjs",
      "react",
      "typescript",
      "tailwindcss",
      "framer motion",
      "zustand",
    ]),
  },
  {
    id: 9,
    project_title: "StaffSync - Employee Management Platform",
    project_image: StaffSync,
    project_desc: `
      <h3>StaffSync: Restaurant Employee Management</h3>
      <p>StaffSync is a comprehensive employee management SaaS platform for restaurants, built with Next.js, TypeScript, Framer Motion, Redux, TailwindCSS, MongoDB, Express, and Node.js. It streamlines scheduling, shift swaps, and team communication with secure authentication and real-time notifications.</p>
      <p><em>- Smart scheduling with calendar integration</em></p>
      <p><em>- Encrypted team messaging and notifications</em></p>
      <p><em>- Role-based access and analytics dashboards</em></p>
      <p><em>- MongoDB database for robust data management</em></p>
    `,
    project_link: "https://restaurant-employee-management-system.vercel.app/",
    skillIds: getSkillIds([
      "nextjs",
      "typescript",
      "framer motion",
      "redux",
      "tailwindcss",
      "mongodb",
      "express",
      "nodejs",
    ]),
  },
  {
    id: 10,
    project_title: "FeelTrx - Mood-Based Music Discovery",
    project_image: FeelTRX,
    project_desc: `
      <h3>FeelTrx: Discover Music by Mood</h3>
      <p>FeelTrx is a mood-based music recommendation platform powered by Next.js, JavaScript, React, and TailwindCSS. It leverages user preference learning and music streaming APIs to deliver personalized playlists and social sharing features.</p>
      <p><em>- Personalized playlists based on emotional context</em></p>
      <p><em>- Integration with major music streaming APIs</em></p>
      <p><em>- Scalable backend for reliability</em></p>
      <p><em>- Mobile-first, responsive design</em></p>
    `,
    project_link: "https://feeltrx.rojanacharya.com",
    skillIds: getSkillIds(["nextjs", "javascript", "react", "tailwindcss"]),
  },
  {
    id: 11,
    project_title: "BeSocial - Social Media Platform (In Progress)",
    project_image: BeSocial,
    project_desc: `
      <h3>BeSocial: Modern Social Media Web App</h3>
      <p>BeSocial is a feature-rich social media application with a minimal UI, built using React, MongoDB, Node.js, Express, React Native, and TailwindCSS. It offers real-time messaging, notifications, and advanced privacy controls for a seamless user experience across web and mobile.</p>
      <p><em>- Like, comment, and save posts with real-time updates</em></p>
      <p><em>- Push notifications and messaging via Socket.io</em></p>
      <p><em>- Role-based access and privacy settings</em></p>
      <p><em>- Cross-platform support with React Native</em></p>
    `,
    project_link: "https://linkedin.com/in/racharya404",
    skillIds: getSkillIds([
      "react",
      "mongodb",
      "nodejs",
      "express",
      "react native",
      "tailwindcss",
    ]),
  },
  {
    id: 12,
    project_title: "Khullabazzar - Multi-Vendor Ecommerce",
    project_image: Khullabazzar,
    project_desc: `
      <h3>Khullabazzar: Multi-Vendor Ecommerce Platform</h3>
      <p>Khullabazzar is a scalable multi-vendor ecommerce solution built with React, MongoDB, Node.js, Express, and TailwindCSS. It features dynamic dashboards, secure authentication, advanced search, and integrated payment gateways.</p>
      <p><em>- Vendor dashboards with analytics and notifications</em></p>
      <p><em>- Category-based product filtering</em></p>
      <p><em>- Stripe payment integration and voucher system</em></p>
      <p><em>- Deployed on AWS with load balancing</em></p>
    `,
    project_link: "https://khullabazzar.vercel.app/",
    skillIds: getSkillIds([
      "react",
      "mongodb",
      "nodejs",
      "express",
      "tailwindcss",
    ]),
  },
  {
    id: 13,
    project_title: "RentYourCar - Car Rental Web App",
    project_image: RentYourCar,
    project_desc: `
      <h3>RentYourCar: Online Car Rental Platform</h3>
      <p>RentYourCar is a user-friendly car rental application developed with PostgreSQL, React, Node.js, and TailwindCSS. It offers real-time availability, secure authentication, advanced search, and integrated payment processing.</p>
      <p><em>- Multi-factor authentication and secure user roles</em></p>
      <p><em>- Location-based search and fuzzy matching</em></p>
      <p><em>- Stripe payment gateway and booking calendar</em></p>
      <p><em>- Owner dashboard with analytics</em></p>
    `,
    project_link: "https://rentyourcar-rojan.vercel.app/",
    skillIds: getSkillIds(["postgres", "react", "nodejs", "tailwindcss"]),
  },
  {
    id: 14,
    project_title: "Downtube - YouTube Video Downloader",
    project_image: DownTube,
    project_desc: `
      <h3>Downtube: YouTube Video & Audio Downloader</h3>
      <p>Downtube is a web application that enables users to download YouTube videos in multiple formats (MP3, MP4, FLV, MOV). Built with React, Node.js, and TailwindCSS for media processing, it features secure authentication and batch download support.</p>
      <p><em>- Download YouTube videos in various formats and qualities</em></p>
      <p><em>- Backend for fast media conversion</em></p>
      <p><em>- Progress tracking, playlist support, and video preview</em></p>
      <p><em>- Secure, intuitive UI with rate limiting</em></p>
    `,
    project_link: "https://yt-downloader-client.vercel.app/",
    skillIds: getSkillIds(["react", "nodejs", "tailwindcss"]),
  },
];

// Certifications Data
export const certification = [
  {
    id: 1,
    certifications_title: "Backend Development and APIs",
    certifications_image: BackendDevandAPIs_fcc,
    certifications_desc: `
      <h4>Backend Development and APIs (freeCodeCamp)</h4>
      <p>Mastered backend development using <strong>Node.js</strong>, <strong>Express</strong>, and <strong>MongoDB</strong>. Covered RESTful API design, authentication, authorization, and database operations with Mongoose. Built and deployed multiple microservices and full-stack applications.</p>
      <p><em>- Dependency management with NPM</em></p>
      <p><em>- RESTful API design and implementation</em></p>
      <p><em>- Authentication and authorization strategies</em></p>
      <p><em>- Projects: Timestamp Microservice, URL Shortener, Exercise Tracker, File Metadata Microservice</em></p>
    `,
    certifications_link:
      "https://freecodecamp.org/certification/fcc938e916e-c451-416a-b547-d27cad819e1e/back-end-development-and-apis",
    skillIds: [8, 9, 7], // Node.js, Express, MongoDB
  },
  {
    id: 2,
    certifications_title: "CSS Fundamentals",
    certifications_image: CSS_Sololearn,
    certifications_desc: `
      <h4>CSS Fundamentals (SoloLearn)</h4>
      <p>Comprehensive understanding of CSS for modern web design, including selectors, specificity, box model, responsive layouts, animations, Flexbox, and Grid. Applied skills to create visually appealing, mobile-friendly interfaces.</p>
      <p><em>- Responsive design and media queries</em></p>
      <p><em>- Advanced animations and transitions</em></p>
      <p><em>- Flexbox and CSS Grid layouts</em></p>
      <p><em>- Applied in: NextJS and React projects</em></p>
    `,
    certifications_link:
      "https://www.linkedin.com/in/racharya404/details/certifications/1635548522149/single-media-viewer/?profileId=ACoAAEhOvg4BD1EXje5NkS08FpTU43Rm6VHrjVw",
    skillIds: [21, 2, 17], // CSS, NextJS, React
  },
  {
    id: 3,
    certifications_title: "Front End Development Libraries",
    certifications_image: JSDSA_fcc,
    certifications_desc: `
      <h4>Front End Development Libraries (freeCodeCamp)</h4>
      <p>Proficient in modern frontend libraries and frameworks including <strong>React</strong>, <strong>Redux</strong>, <strong>Bootstrap</strong>, <strong>jQuery</strong>, and <strong>SASS</strong>. Built interactive, component-based UIs and managed complex state efficiently.</p>
      <p><em>- React and Redux integration</em></p>
      <p><em>- Bootstrap for responsive layouts</em></p>
      <p><em>- jQuery for DOM manipulation</em></p>
      <p><em>- Projects: Random Quote Machine, Markdown Previewer, Drum Machine, Calculator</em></p>
    `,
    certifications_link:
      "https://freecodecamp.org/certification/fcc938e916e-c451-416a-b547-d27cad819e1e/front-end-development-libraries",
    skillIds: [17, 22, 23, 24, 25], // React, Redux, Bootstrap, jQuery, SASS
  },
  {
    id: 4,
    certifications_title: "Responsive Web Design",
    certifications_image: ResWebDesign_fcc,
    certifications_desc: `
      <h4>Responsive Web Design (freeCodeCamp)</h4>
      <p>Expertise in semantic HTML, advanced CSS, and accessibility best practices. Built responsive layouts and interactive web pages optimized for SEO and usability.</p>
      <p><em>- Semantic HTML5 and ARIA roles</em></p>
      <p><em>- Complex CSS styling and animations</em></p>
      <p><em>- Accessibility and mobile-first design</em></p>
      <p><em>- Projects: Registration Forms, Photo Gallery, Nutrition Label, City Skyline, Magazine Layout</em></p>
    `,
    certifications_link:
      "https://freecodecamp.org/certification/fcc938e916e-c451-416a-b547-d27cad819e1e/responsive-web-design",
    skillIds: [21, 26], // CSS, HTML
  },
  {
    id: 5,
    certifications_title: "JavaScript Algorithms and Data Structures",
    certifications_image: FrontendDevLibraries_fcc,
    certifications_desc: `
      <h4>JavaScript Algorithms and Data Structures (freeCodeCamp)</h4>
      <p>In-depth knowledge of JavaScript ES6+, regular expressions, debugging, data structures, and algorithmic problem-solving. Applied concepts in TypeScript and frontend optimization.</p>
      <p><em>- Object-oriented and functional programming</em></p>
      <p><em>- Algorithm scripting and complex logic</em></p>
      <p><em>- Projects: Palindrome Checker, Roman Numeral Converter, Cash Register</em></p>
    `,
    certifications_link:
      "https://freecodecamp.org/certification/fcc938e916e-c451-416a-b547-d27cad819e1e/javascript-algorithms-and-data-structures",
    skillIds: [12, 5], // JavaScript, TypeScript
  },
  {
    id: 6,
    certifications_title: "Data Visualization",
    certifications_image: DataVisualization_fcc,
    certifications_desc: `
      <h4>Data Visualization (freeCodeCamp)</h4>
      <p>Specialized in data visualization using <strong>D3.js</strong>, <strong>SVG</strong>, and <strong>AJAX</strong>. Built interactive charts, heatmaps, and dashboards for data-driven applications. Applied skills in Python data analysis and reporting.</p>
      <p><em>- Bar charts, scatterplots, heatmaps, treemaps</em></p>
      <p><em>- SVG manipulation and JSON APIs</em></p>
      <p><em>- Applied in: Python analytics and dashboard projects</em></p>
    `,
    certifications_link:
      "https://freecodecamp.org/certification/fcc938e916e-c451-416a-b547-d27cad819e1e/data-visualization",
    skillIds: [20, 10, 27], // Data Visualization, Python, D3.js
  },
  {
    id: 7,
    certifications_title: "HTML Fundamentals",
    certifications_image: HTML_Sololearn,
    certifications_desc: `
      <h4>HTML Fundamentals (SoloLearn)</h4>
      <p>Solid foundation in HTML5, semantic markup, forms, multimedia, and accessibility. Applied best practices for SEO-optimized, responsive web content in modern frameworks.</p>
      <p><em>- Semantic HTML and document structure</em></p>
      <p><em>- Forms and input validation</em></p>
      <p><em>- Accessibility and multimedia integration</em></p>
      <p><em>- Applied in: NextJS and React projects</em></p>
    `,
    certifications_link:
      "https://www.linkedin.com/in/racharya404/details/certifications/1635548520498/single-media-viewer/?profileId=ACoAAEhOvg4BD1EXje5NkS08FpTU43Rm6VHrjVw",
    skillIds: [26, 2, 17], // HTML, NextJS, React
  },
  {
    id: 8,
    certifications_title: "C#",
    certifications_image: CSharp_Sololearn,
    certifications_desc: `
      <h4>C# Fundamentals (SoloLearn)</h4>
      <p>Learned object-oriented programming, type system, memory management, LINQ, async programming, and error handling in C#. Applied in backend services, desktop apps, and game development basics.</p>
      <p><em>- OOP principles and .NET platform</em></p>
      <p><em>- LINQ for data querying</em></p>
      <p><em>- Asynchronous programming and exception handling</em></p>
    `,
    certifications_link:
      "https://www.linkedin.com/in/racharya404/details/certifications/1635548520498/single-media-viewer/?profileId=ACoAAEhOvg4BD1EXje5NkS08FpTU43Rm6VHrjVw",
    skillIds: [12], // C#
  },
];

// Helper function to get related projects and certifications for a skill
export const getSkillRelations = (skillId) => {
  const relatedProjects = projects.filter(
    (project) => project.skillIds && project.skillIds.includes(skillId)
  );

  const relatedCertifications = certification.filter(
    (cert) => cert.skillIds && cert.skillIds.includes(skillId)
  );

  return {
    projects: relatedProjects,
    certifications: relatedCertifications,
  };
};
